import Navbar from '../../common/components/Navbar/Navbar';
import { Outlet } from 'react-router-dom';
import {
  Box,
  // useMediaQuery
} from '@mui/material';
import Sidebar from './components/Sidebar';
import { useEffect, useState } from 'react';
// import { useTheme } from '@emotion/react';

const MainLayoutContainer = (props) => {
  // const [sidebarSize, setSidebarSize] = useState("normal")
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [sidebar_opened, set_sidebar_opened] = useState(false);
  useEffect(() => {
    // Add event listener for keydown event
    // console.log("adding event");
    document.addEventListener('keydown', handleKeyDown);
    // Clean up the event listener on component unmount
    return () => {
      // console.log("removing event during cleanup");
      document.removeEventListener('keydown', handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sidebar_opened]);

  const handleKeyDown = (event) => {
    // Check if the combination of keys is pressed
    if (event.ctrlKey && event.altKey && event.code === 'KeyH') {
      handle_sidebar_toggle();
    }
  };

  // const handleSidebarToggle = () => {
  //   set_sidebar_opened((prevOpened) => !prevOpened);
  // };
  const handle_sidebar_toggle = () => {
    switch (sidebar_opened) {
      case true:
        set_sidebar_opened(false);
        return;
      case false:
        set_sidebar_opened(true);
        return;
      default:
        set_sidebar_opened(false);
        return;
    }
  };
  return (
    <Box>
      <Navbar handle_sidebar_toggle={handle_sidebar_toggle} />
      <Box
        sx={{
          display: 'flex',
          minHeight: 'calc(100vh - 60px)',
        }}
      >
        <Sidebar sidebar_opened={sidebar_opened} />
        <Box
          className="relative"
          sx={{
            flex: 1,
            // border: '1px solid green',
            height: 'calc(100vh - 60px)',
            overflowY: 'auto',
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default MainLayoutContainer;
